import Select from 'react-select';
import type {OptionTypeBase, OptionsType} from 'react-select';

interface SelectEditorProps {
  value: string;
  onChange: (value: string) => void;
  options: OptionsType<OptionTypeBase>;
  rowHeight: number;
  menuPortalTarget: Element;
  isSearchable?: boolean;
  isClearable?: boolean;
}

export default function SelectEditor({
  value,
  onChange,
  options,
  rowHeight,
  menuPortalTarget,
  isSearchable = true,
  isClearable = false,
}: SelectEditorProps) {
  return (
    <Select
      autoFocus
      defaultMenuIsOpen
      isClearable={isClearable}
      value={options.find(o => o.value === value)}
      onChange={o => onChange(o?.value)}
      options={options}
      menuPortalTarget={menuPortalTarget as HTMLElement}
      placeholder={'請選擇'}
      isSearchable={isSearchable}
      styles={{
        control: provided => ({
          ...provided,
          height: rowHeight - 1,
          minHeight: 30,
          lineHeight: 'normal',
        }),
        dropdownIndicator: provided => ({
          ...provided,
          height: rowHeight - 1,
        }),
      }}
    />
  );
}
